

import { Box, Card, Typography, Button } from '@mui/material';
import {
  MRT_RowData,
  MaterialReactTable,
  useMaterialReactTable, //import alternative sub-component if we do not want toolbars
  type MRT_ColumnDef,
  type MRT_TableOptions,
  type MRT_RowSelectionState
} from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { PaginationState } from "@tanstack/react-table";


interface SampleTablePedidoProps<T extends MRT_RowData> extends MRT_TableOptions<T> {
  columns: MRT_ColumnDef<T>[];
  data: T[];
  pagination: PaginationState | undefined
  setPagination: any
  rowCount: number
  rowNumber?: boolean;
  enablePagination?: boolean;
  density?: 'comfortable' | 'compact' | 'spacious';
  // enableTopToolbar?: boolean;
  isLoading?: boolean;
  backgroundColor?: string
  muiTableBodyRowProps?: any;

  ///* filtro
  enableManualFiltering?: boolean;
  onColumnFiltersChange?: (filters: any) => void;
  columnFilters?: any;
  enableColumnFilters?: boolean
  enableColumnActions?: boolean

  //Mostrar boton
  
  onDownload?: ()=> void;
  downloadText?: string;

  //Row Selection (checkboxes)
  enableRowSelection?: boolean;
  rowSelection?: MRT_RowSelectionState;
  onRowSelectionChange?: any;
  getRowId?: (row: T) => string;
  enableSelectAll?:boolean;
}

const SampleTablePedidoPagination = <T extends MRT_RowData>({
  columns,
  data,
  density = 'comfortable',
  rowNumber = false,
  // enableTopToolbar = false,
  isLoading = false,
  pagination,
  setPagination,
  rowCount,
  //suma
  muiTableBodyRowProps,
  enableManualFiltering = false,
  onColumnFiltersChange,
  columnFilters,
  columnFilterDisplayMode = 'subheader',

  enableColumnFilters = false,
  enableColumnActions = false,
  ///
  onDownload,
  downloadText = "Descargar", // Valor por defecto si no envían texto

  enableRowSelection = false,
  rowSelection,
  onRowSelectionChange,
  getRowId,
  enableSelectAll=true,

}: SampleTablePedidoProps<T>) => {

  const table = useMaterialReactTable({
    columns,
    data,
    localization: MRT_Localization_ES,
    enableRowNumbers: rowNumber,
    enableRowVirtualization: rowNumber,
    enableSorting: false,
    enableFullScreenToggle: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableColumnActions: enableColumnActions,
    enableRowActions: false,
    enableRowSelection,
    enableTopToolbar: true,
    ...(enableRowSelection && getRowId && { getRowId }),
    ...(enableRowSelection && onRowSelectionChange && { onRowSelectionChange }),
    state: {
      ...(enableRowSelection && rowSelection && { rowSelection }),
      expanded: true,
      density: density,
      isLoading: isLoading,
      pagination: pagination,
      ...(enableManualFiltering && { columnFilters }),

    },
    enableSelectAll,
    displayColumnDefOptions:{
        'mrt-row-select':{
            header:'✔'
        }
    },
    ///* filtering
    enableColumnFilters: enableColumnFilters,
    columnFilterDisplayMode: columnFilterDisplayMode,
    ...(enableManualFiltering && {
      manualFiltering: enableManualFiltering, // server-side filtering by columns
      onColumnFiltersChange: onColumnFiltersChange,
    }),

    ///* pagniacion
    enablePagination: true,
    manualPagination: true,
    rowCount: rowCount,
    onPaginationChange: setPagination,

    ///* estilos
    muiTablePaperProps: {
      elevation: 0,
    },
    muiPaginationProps: {
      rowsPerPageOptions: [10, 20, 50, 100, 200],
      showRowsPerPage: true,
      showFirstButton: true,
      showLastButton: true,
    },
    muiTableBodyCellProps: {
      align: 'center',
    },
    muiTableHeadCellProps: {
      align: 'center',
    },
    muiTableBodyRowProps,
    renderTopToolbarCustomActions: () => (

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', width: '100%' }}>
        <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
          Total de Registros: {rowCount}
        </Typography>
        
        {onDownload && (
          <Button 
      onClick={onDownload}
      sx={{
    position: 'relative',
    overflow: 'hidden',
    px: 3,
    py: 1.2,
    borderRadius: '14px',

    background: 'linear-gradient(145deg, #6366f1, #4f46e5)',
    color: '#fff',

    boxShadow: `
      0 10px 25px rgba(99,102,241,.35),
      inset 1px 1px 2px rgba(255,255,255,.18),
      inset -2px -2px 6px rgba(0,0,0,.18)
    `,

    transition: 'all .3s ease',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-120px',
      width: '90px',
      height: '100%',
      background:
        'linear-gradient(120deg, transparent, rgba(255,255,255,.45), transparent)',
      transform: 'skewX(-25deg)',
      transition: '0.8s',
    },

    '&:hover::before': {
      left: '130%',
    },

    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: `
        0 16px 30px rgba(99,102,241,.45),
        inset 1px 1px 2px rgba(255,255,255,.22),
        inset -2px -2px 8px rgba(0,0,0,.22)
      `,
    },

    '&:active': {
      transform: 'scale(.97)',
    },
  }}
    >
      {downloadText}
    </Button>
        )}
      </Box>
       


    ),
  });

  return (
    <Card>
      <Box
        sx={{
          width: '100%',
        }}
      >
        <MaterialReactTable table={table} />
      </Box>
    </Card>
  );
};

export default SampleTablePedidoPagination;